/* eslint-disable flowtype/require-valid-file-annotation */

import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

// Material UI
import { withStyles } from 'material-ui/styles';

// Styling
import styles from './styles';

// Components
import ApplicationBar from './components/ApplicationBar';
import CoreContent from './components/CoreContent';

class Login extends React.Component {
  render() {
    const { classes, theme, location } = this.props;
    return (
      <div className={classes.root}>
        <div className={classes.appFrame}>
          <ApplicationBar />
          <CoreContent />
        </div>
      </div>
    )
  }
}

Login.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withRouter(withStyles(styles, { withTheme: true })(Login));



// WEBPACK FOOTER //
// ./src/scenes/Login/index.js